
import axios from 'axios';
import Vue from 'vue';

import VideoPlayer from '@media/components/video/VideoPlayer.vue';
import ContentImage from '@core/components/UI/ContentImage.vue';

import { GetLiveStreams, Stream } from '@root/common/types/getLiveStreams';
import { faTimes } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import isMobileView from '@root/common/utils/isMobileView';

interface Data {
  activeStream: Stream | null;
  streams: Stream[];
}

interface Methods {
  clearInterval: () => void;
  getActiveStream: () => void;
  handleClick: () => void;
  handleClose: () => void;
}

interface Computed {
  isMobileOrTablet: boolean;
  isWowzaStream: boolean;
}

interface lsaWindow extends Window {
  _dlf: any;
  ga: any;
  geoipdata: any;
  lsa: any;
}

declare let window: lsaWindow;

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    VideoPlayer,
    ContentImage,
  },
  data() {
    return {
      activeStream: null,
      streams: [],
      faTimes,
    };
  },
  computed: {
    isMobileOrTablet() {
      return isMobileView();
    },
    isWowzaStream() {
      return this.activeStream?.content.leadElement?.content[0]?.attrs?.streamData?.videoVendorId === 'wowza';
    },
  },
  watch: {
    activeStream(value) {
      if (value && this.activeStream) {
        const expires = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toUTCString();
        window.document.cookie = `dLSA_${this.activeStream.id}=1;expires=${expires};path=/`;

        if (window.ga) {
          window.ga('send', 'event', 'Video', 'teaserPlayerShow');
        }

        this.clearInterval();

        if (this.isMobileOrTablet) {
          setTimeout(
            () => {
              window.document.getElementById(`lsa-${this.activeStream?.id}`)?.classList.add('live-stream-announcement--active');
            },
            2000,
            this.activeStream?.id
          );

          setTimeout(
            () => {
              window.document.getElementById(`lsa-${this.activeStream?.id}`)?.classList.remove('live-stream-announcement--active');
            },
            10000,
            this.activeStream?.id
          );
        }
      }
    },
  },
  async mounted() {
    const { enabled } = this.$channelConfig('features').lsa;

    if (process.client) {
      if (
        !/\.lt\/video\//.test(window.location.href) &&
        !/\.lt\/puslapis\/premium\//.test(window.location.href) &&
        window.document.cookie.indexOf('__dLSA') === -1 &&
        enabled
      ) {
        this.getActiveStream();

        window.lsa = setInterval(() => {
          this.getActiveStream();
        }, 15000);
      }
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (typeof window.lsa !== 'undefined') {
        clearInterval(window.lsa);
      }
    },
    async getActiveStream() {
      const response = await axios.get('/api/get-live-streams', { timeout: 1000 });
      const { items }: GetLiveStreams['data']['streams'] = response.data;

      if (items.length) {
        items.forEach((item) => {
          if (window.document.cookie.indexOf(`dLSA_${item.id}`) === -1) {
            this.clearInterval();
            this.activeStream = item;
          }
        });
      }
    },
    handleClick() {
      if (this.isMobileOrTablet) {
        window.location.href = `https://www.delfi.lt/a/${this.activeStream?.id}`;
      } else {
        window.open(`https://www.delfi.lt/a/${this.activeStream?.id}`, '_blank');
      }

      if (window.ga) {
        window.ga('send', 'event', 'Video', 'teaserPlayerClick');
      }
    },
    handleClose() {
      window.document.getElementById(`lsa-${this.activeStream?.id}`)?.remove();

      if (window.ga) {
        window.ga('send', 'event', 'Video', 'teaserPlayerClose');
      }
    },
  },
});
